import { render, staticRenderFns } from "./about_h5.vue?vue&type=template&id=5bbb8447&scoped=true"
import script from "./about_h5.vue?vue&type=script&lang=js"
export * from "./about_h5.vue?vue&type=script&lang=js"
import style0 from "./about_h5.vue?vue&type=style&index=0&id=5bbb8447&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb8447",
  null
  
)

export default component.exports